// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"d852e7d3","423":"e2a9f6c0"}[chunkId] + ".chunk.js";
};